/**
 * @fileoverview Route factory utilities for creating route definitions with
 * consistent error handling.
 */

import type { RouteObject } from 'react-router';
import { PageErrorBoundary } from '../components/PageErrorBoundary';

/**
 * Configuration for creating a route with standard error handling.
 */
export interface RouteConfig {
  path: string;
  Component: React.ComponentType;
}

/**
 * Creates a route object with the standard PageErrorBoundary.
 */
export function createRoute(config: RouteConfig): RouteObject {
  return {
    path: config.path,
    Component: config.Component,
    errorElement: <PageErrorBoundary />,
  };
}

/**
 * Creates multiple route objects from an array of configurations.
 */
export function createRoutes(configs: RouteConfig[]): RouteObject[] {
  return configs.map(createRoute);
}

